<template>
  <div class="mt-3">
    <h2 class="fw-bold">
      <router-link to="/admin" class="text-teal" title="Área Administrativa">
        Área Administrativa
      </router-link>
      <span class="text-gray">/ Sincronizações</span>
    </h2>
  </div>
  <div class="card">
    <div class="table-responsive">
      <table class="table table-sm table-bordered table-striped" width="100%">
        <thead class="bg-teal text-white text-center">
          <tr>
            <th>Cod. Sentença</th>
            <th>Título</th>
            <th>Tabela</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="text-center">ETHOS.WEB.02</td>
            <td>Sincroniza os centros de custos</td>
            <td class="text-center">cc</td>
            <td class="text-center">
              <button
                type="button"
                class="btn btn-sm btn-outline-success btn-icon"
                title="Sincronizar Dados"
                :disabled="lineTableClicked === 'cc'"
                @click="syncs('cc', 'syncsCentrosCustos')"
              >
                <span v-if="lineTableClicked === 'cc'">
                  <i class="ph-spinner spinner" />
                </span>
                <span v-else>
                  <i class="ph-arrows-clockwise"></i>
                </span>
              </button>
            </td>
          </tr>
          <tr>
            <td class="text-center">ETHOS.WEB.03</td>
            <td>Sincroniza amarração de centros de custos com usuários</td>
            <td class="text-center">ccusuario</td>
            <td class="text-center">
              <button
                type="button"
                class="btn btn-sm btn-outline-success btn-icon"
                title="Sincronizar Dados"
                :disabled="lineTableClicked === 'ccusuario'"
                @click="syncs('ccusuario', 'syncsCentrosCustosUsuarios')"
              >
                <span v-if="lineTableClicked === 'ccusuario'">
                  <i class="ph-spinner spinner" />
                </span>
                <span v-else>
                  <i class="ph-arrows-clockwise"></i>
                </span>
              </button>
            </td>
          </tr>
          <tr>
            <td class="text-center">ETHOS.WEB.04</td>
            <td>Sincroniza as naturezas orçamentárias</td>
            <td class="text-center">no</td>
            <td class="text-center">
              <button
                type="button"
                class="btn btn-sm btn-outline-success btn-icon"
                title="Sincronizar Dados"
                :disabled="lineTableClicked === 'no'"
                @click="syncs('no', 'syncsNaturezasOrcamentarias')"
              >
                <span v-if="lineTableClicked === 'no'">
                  <i class="ph-spinner spinner" />
                </span>
                <span v-else>
                  <i class="ph-arrows-clockwise"></i>
                </span>
              </button>
            </td>
          </tr>
          <tr>
            <td class="text-center">ETHOS.WEB.05</td>
            <td>
              Sincroniza amarração de centros de custos com naturezas
              orçamentárias
            </td>
            <td class="text-center">ccno</td>
            <td class="text-center">
              <button
                type="button"
                class="btn btn-sm btn-outline-success btn-icon"
                title="Sincronizar Dados"
                :disabled="lineTableClicked === 'ccno'"
                @click="
                  syncs('ccno', 'syncsCentrosCustosNaturezasOrcamentarias')
                "
              >
                <span v-if="lineTableClicked === 'ccno'">
                  <i class="ph-spinner spinner" />
                </span>
                <span v-else>
                  <i class="ph-arrows-clockwise"></i>
                </span>
              </button>
            </td>
          </tr>
          <tr>
            <td class="text-center">ETHOS.WEB.10</td>
            <td>
              Sincroniza listagem dos centros de custos que possuem controle de
              metas
            </td>
            <td class="text-center">meta</td>
            <td class="text-center">
              <button
                type="button"
                class="btn btn-sm btn-outline-success btn-icon"
                title="Sincronizar Dados"
                :disabled="lineTableClicked === 'meta'"
                @click="syncs('meta', 'syncsMetas')"
              >
                <span v-if="lineTableClicked === 'meta'">
                  <i class="ph-spinner spinner" />
                </span>
                <span v-else>
                  <i class="ph-arrows-clockwise"></i>
                </span>
              </button>
            </td>
          </tr>
          <tr>
            <td class="text-center">ETHOS.WEB.11</td>
            <td>Sincroniza dados utilizados no relatório orçamentário</td>
            <td class="text-center">orcamentario</td>
            <td class="text-center">
              <button
                type="button"
                class="btn btn-sm btn-outline-success btn-icon"
                title="Sincronizar Dados"
                :disabled="lineTableClicked === 'relatorio_orcamentario'"
                @click="
                  syncs('relatorio_orcamentario', 'syncsRelatorioOrcamentario')
                "
              >
                <span v-if="lineTableClicked === 'relatorio_orcamentario'">
                  <i class="ph-spinner spinner" />
                </span>
                <span v-else>
                  <i class="ph-arrows-clockwise"></i>
                </span>
              </button>
            </td>
          </tr>
          <tr>
            <td class="text-center">ETHOS.WEB.09</td>
            <td>
              Atualiza valores orçados e bloqueados para o ano do orçamento
              ativo
            </td>
            <td class="text-center">registro</td>
            <td class="text-center">
              <button
                type="button"
                class="btn btn-sm btn-outline-success btn-icon"
                title="Sincronizar Dados"
                :disabled="lineTableClicked === 'registro'"
                @click="syncs('registro', 'syncsValoresOrcadosBloqueados')"
              >
                <span v-if="lineTableClicked === 'registro'">
                  <i class="ph-spinner spinner" />
                </span>
                <span v-else>
                  <i class="ph-arrows-clockwise"></i>
                </span>
              </button>
            </td>
          </tr>
          <tr>
            <td class="text-center">ETHOS.WEB.16</td>
            <td>
              Copia os valores realizados do RM do primeiro semestre (jan-jun)
              para a coluna reformulado para o ano vigente ({{
                new Date().getFullYear()
              }})
            </td>
            <td class="text-center">
              registrorealizado <br />
              registro
            </td>
            <td class="text-center">
              <button
                type="button"
                class="btn btn-sm btn-outline-success btn-icon"
                title="Sincronizar Dados"
                :disabled="lineTableClicked === 'registrorealizado'"
                @click="
                  syncs(
                    'registrorealizado',
                    'syncsValoresRealizadosParaReformulado',
                  )
                "
              >
                <span v-if="lineTableClicked === 'registrorealizado'">
                  <i class="ph-spinner spinner" />
                </span>
                <span v-else>
                  <i class="ph-arrows-clockwise"></i>
                </span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Sincronizacoes',

  data() {
    return {
      lineTableClicked: '',
    }
  },

  computed: {
    ...mapGetters(['user']),
  },

  methods: {
    async syncs(lineTableClicked, dispatch) {
      try {
        this.lineTableClicked = lineTableClicked

        const response = await this.$store.dispatch(dispatch)
        this.$root.$refs.notification.success(response.message)

        this.lineTableClicked = ''
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
        this.lineTableClicked = ''
      }
    },
  },
}
</script>
